( function( $ ) {
  $( '.__tabs a' ).on( 'click', function( e ) {
    e.preventDefault();

    var clicked_parent = $( this ).parent();
    var data_show = clicked_parent.data( 'tab' );

    /* Change the active tab */
    $( '.__tabs > li' ).removeClass( '__active' );
    clicked_parent.addClass( '__active' );

    /* Change the active content */
    $( '.__contents > div' ).removeClass( '__active' );
    $( 'div[data-content="' + data_show + '"]' ).addClass( '__active' );

    /* Activate the smooth scrolling on mobile view */
    if( $( window ).width() <= 622 ) {
      $( 'html, body' ).animate( {
        scrollTop: $( '.__contents' ).offset().top - 100
      }, 2000 );
    }
  } );

  $('.close-buttonx').on('click', function(){		  
	$(".hamburger").trigger("click");
  });
} ) ( jQuery );